import BSHtmlBaseBillableStrategy from './BSHtmlBaseBillableStrategy'

export default function BSHtmlBillableAmountStrategy() {}

BSHtmlBillableAmountStrategy.prototype = new BSHtmlBaseBillableStrategy();

BSHtmlBillableAmountStrategy.prototype.addFirstHeaderRowCells = function ( row, levelsNumber ) {
    this.addCell( row, this.message( "report.billing_summary.overall_amount.html", [SystemSettings.currencySign] ),
                  "billableAmount", 1, levelsNumber );
};

BSHtmlBillableAmountStrategy.prototype.addColumnValueCells = function ( row ) {
    this.addMoneyValueCell(row);
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BSHtmlBillableAmountStrategy.js